import React, { FC } from 'react';

import { useModals } from '@contexts/common/ModalContext';

import RedeemModal from '@modules/modals/bonds/RedeemModal';
import AccountModal from '@modules/modals/common/AccountModal';
import ChainModal from '@modules/modals/common/ChainModal';
import WalletConnectModal from '@modules/modals/common/WalletConnectModal';
import WrongNetworkModal from '@modules/modals/common/WrongNetworkModal';

import { MODAL_TYPES } from '@constants/common/modals.constants';

import { RedeemModalProps } from '@app-types/common/modal.types';

const Modals: FC = () => {
  const { state } = useModals();

  return (
    <>
      {state.current === MODAL_TYPES.CONNECT_WALLET_MODAL && (
        <WalletConnectModal />
      )}
      {state.current === MODAL_TYPES.CHAIN_MODAL && <ChainModal />}
      {state.current === MODAL_TYPES.ACCOUNT_MODAL && <AccountModal />}
      {state.current === MODAL_TYPES.WRONG_NETWORK_MODAL && (
        <WrongNetworkModal />
      )}
      {state.current === MODAL_TYPES.BONDS_REDEEM_MODAL && (
        <RedeemModal {...(state.props as RedeemModalProps)} />
      )}
    </>
  );
};

export default Modals;
